import LoginForm from "../LoginForm";
import AuthLayout from "../AuthLayout/AuthLayout";

const Main = () => (
  <AuthLayout>
    <LoginForm />
  </AuthLayout>
);

export default Main;
